import { parseInputNumberValue } from "#shared/helpers/prices";

export const isValidEuroAmount = (value: string) => {
  const euros = parseInputNumberValue(value);
  return value !== "" && !Number.isNaN(euros) && euros >= 0;
};
